export const MARKER_NAME_PREFIX = 'i2g';

export enum MarkerNamesEnum {
  time_to_first_paint = 'time_to_first_paint',
  time_to_app_load = 'time_to_app_load',
  time_to_interactive = 'time_to_interactive',
}

export interface IPerformanceResult {
  [name: string]: number;
}
